import dataApi from '../api/data';
import contentApi from '../api/content';

const getInitialAppData = async (ctx, config = {}) => {
  const [geo, countries, skuProducts, productsData, categoriesData, banner] = await Promise.all([
    dataApi.getGeo(ctx, config.defaultCountryCode),
    dataApi.getCountries(),
    dataApi.getSkuProducts(),
    contentApi.products(config.productIds),
    contentApi.categories(config.categoryIds),
    contentApi.banner(),
  ]);

  if (countries.error) {
    throw new Error(`getInitialAppData dataApi.getCountries(): ${countries.error.body}`);
  }

  if (skuProducts.error) {
    throw new Error(`getInitialAppData dataApi.getSkuProducts(): ${skuProducts.error.body}`);
  }

  return {
    countryCode: geo.countryCode,
    realCountryCode: geo.realCountryCode,
    countries: countries.data,
    skuProducts: skuProducts.data,
    productsData: productsData.map(({ id, shortDescription, caption }) => ({
      id,
      shortDescription,
      name: caption,
    })),
    categoriesData: categoriesData.map(
      ({ id, shortDescription, caption, seoTitle, seoDescription, heroTitle }) => ({
        id,
        shortDescription,
        name: caption,
        seoTitle,
        seoDescription,
        heroTitle,
      }),
    ),
    banner,
  };
};

export default getInitialAppData;
